import Vuex from "vuex";
import Vue from "vue";
import createPersistedState from "vuex-persistedstate";
import client from "./utils/client.js";
import axios from "axios";
import { errorHandler } from "@/utils/errorHandler";
import {
  setEmployeeDailySubsidy,
  setWeeklyEmployeeSubsidy,
  getOfficeTeams,
  logOut
} from "./utils/api";
import router from "./router/index.js";
Vue.use(Vuex);

const apiToken = process.env.AIR_TABLE_API_KEY;
const airTableApp = process.env.AIR_TABLE_APP;
const airTableName = process.env.AIR_TABLE_NAME;

const initialState = {
  cart: {
    items: [],
    isSubsidy: false
  },
  cartOfficeAdmin: {
    items: [],
    isSubsidy: false
  },
  paymentCart: {
    picked: "pay_from_subsidy",
    payable: 0,
    grandTotal: 0
  },
  paymentCartOfficeAdmin: {
    picked: "pay_from_subsidy",
    payable: 0,
    grandTotal: 0
  },
  currentEmp: null,
  previouslySelectedMeal: null,
  employee: {
    first_name: null,
    last_name: null,
    employees: [],
    locations: []
  },
  tip: "0",
  defaultTip: true,
  tipOfficeAdmin: "0",
  defaultTipOfficeAdmin: true,
  restaurantDate: {
    id: "",
    slot: "",
    selectedDate: ""
  },
  restaurantDirectoryData: {
    dietaryChosenTags: [],
    cuisineChosenTags: []
    // go to where allusertags is updated. the action or mutation
  },
  adminMenuOpen: false,
  adminMenuButtonHide: false,
  isAdminLogin: false,
  alert: false,
  alertMsg: "",
  restaurantOrder: null,
  listOfOfficeEmployeesAll: [],
  officeAdmins: [],
  officeTeamsAll: [],
  selectedUserToPlaceOrder: null,
  officeTeam: null,
  currentOpenedMenuItemId: "",
  ordersDateOA: new Date(),
  location: null,
  currentOrganization: null,
  timezone: "",
  showDefaultOfficeSelectionModal: false,
  validLocations: [],
  //for Guest user
  uncheckedoutOrderId: "",
  invitationSlug: "",
  uncheckedoutOrder: {
    items: [],
    isSubsidy: false
  },
  // Subsidy details
  subsidyDetails: {},
  subsidyDetailsOfficeAdmin: {}
};

const state = Vue.util.extend({}, initialState);

export default new Vuex.Store({
  state,
  actions: {
    FETCH_CART(state) {
      client()
        .get(
          `/api/v2/company/cart_items?employee_id=${
            state.getters.getFirstEmployeeId
          }&tip_percentage=${state.state.tip / 100}`
        )
        .then(response => {
          state.commit("SET_CART", response.data);
        })
        .catch(err => errorHandler(err));
    },
    FETCH_UNCHECKEDOUT_ORDER(state) {
      client()
        .get(
          `/api/v2/guest/uncheckedout_orders/${state.getters.getUncheckedoutOrderId}?slug=${state.getters.getInvitationSlug}`
        )
        .then(response => {
          state.commit("SET_UNCHECKED_OUT_ORDER", response.data?.data);
        })
        .catch(err => errorHandler(err));
    },
    FETCH_CART_OFFICE_ADMIN(state, params) {
      client()
        .get(
          `/api/v2/company/cart_items?employee_id=${
            state.getters.getFirstEmployeeId
          }&cart_employee_id=${
            state.getters.getSelectedUserPlaceOrder
          }&tip_percentage=${state.state.tipOfficeAdmin / 100}`
        )
        .then(response => {
          state.commit("SET_CART_OFFICE_ADMIN", response.data);
        })
        .catch(err => errorHandler(err));
    },
    FETCH_RESTAURANT_DIRECTORY_FILTERS(store, filters) {
      store.commit("SET_RESTAURANT_DIRECTORY_FILTERS", filters);
    },
    REMOVE_ITEM_FROM_CART(state, params) {
      client()
        .delete(
          `/api/v1/company/cart_items/${params.id}?employee_id=${state.getters.getFirstEmployeeId}`
        )
        .then(_ => state.dispatch("FETCH_CART"))
        .catch(err => errorHandler(err));
    },
    REMOVE_ITEM_FROM_GUEST_CART(state, params) {
      //GUEST user
      client()
        .delete(
          `/api/v2/guest/cart_items/${params.id}?slug=${state.getters.getInvitationSlug}&uncheckedout_order_id=${state.getters.getUncheckedoutOrderId}`
        )
        .then(_ => state.dispatch("FETCH_UNCHECKEDOUT_ORDER"))
        .catch(err => errorHandler(err));
    },
    REMOVE_ITEM_FROM_CART_OFFICE_ADMIN(state, params) {
      client()
        .delete(
          `/api/v2/company/cart_items/${params.id}?employee_id=${state.getters.getFirstEmployeeId}&cart_employee_id=${state.getters.getSelectedUserPlaceOrder}`
        )
        .then(_ => state.dispatch("FETCH_CART_OFFICE_ADMIN"))
        .catch(err => errorHandler(err));
    },
    SET_EMPLOYEE(state, data) {
      state.commit("SET_EMPLOYEE", data);

      state.dispatch("FETCH_EMPLOYEE_PROFILE", {
        empId: state.getters.getFirstEmployeeId
      });
    },
    FETCH_LOCATION(state, data) {
      client()
        .get(
          `/api/v1/company/locations/${state.getters.getOrganizationId}?employee_id=${state.getters.getFirstEmployeeId}`
        )
        .then(response => {
          state.commit("SET_LOCATION", response.data);
        })
        .catch(err => errorHandler(err));
    },
    FETCH_EMPLOYEE_PROFILE(state, data) {
      let url = `/api/v1/company/profiles/${data?.empId}?employee_id=${data?.empId}`;

      if (
        state?.state?.currentOrganization &&
        (state?.state?.currentOrganization?.attributes?.soft_deleted ||
          !state?.state?.currentOrganization?.attributes?.active)
      )
        url = `${url}&login_discarded_employee=true`;

      if (data?.empId)
        client()
          .get(url)
          .then(response => {
            state.commit("SET_CURRENT_EMPLOYEE", response?.data);
          })
          .catch(err => errorHandler(err));
    },
    CLEAR_CART(state) {
      client()
        .delete(
          `/api/v2/company/cart_items?employee_id=${state.getters.getFirstEmployeeId}&remove_all_cart_items=true`
        )
        .then(_ => state.dispatch("FETCH_CART"))
        .catch(err => errorHandler(err));
    },
    CLEAR_CART_OFFICE_ADMIN(state) {
      client()
        .delete(
          `/api/v2/company/cart_items?employee_id=${state.getters.getFirstEmployeeId}&cart_employee_id=${state.getters.getSelectedUserPlaceOrder}&remove_all_cart_items=true`
        )
        .then(_ => state.dispatch("FETCH_CART_OFFICE_ADMIN"))
        .catch(err => errorHandler(err));
    },
    SET_RESTAURANT_DATE(state, data) {
      state.commit("UPDATE_RESTAURANT_DATE", data);
    },
    SET_ADMIN_LOGIN(state) {
      state.commit("TOGGLE_ADMIN_LOGIN");
    },
    // HANDLE_UPDATING_EMPLOYEE_SUBSIDY(state, newData) {
    //   if(newData.timeSlot.includes("weekly")) {
    //     const chosenTimeSlot = newData.timeSlot.includes("lunch")
    //     ? "lunch"
    //     : "dinner";
    //     const mealType = "&meal=" + chosenTimeSlot;
    //     const employeeIdParam = "?employee_id=" + newData.id;
    //     const limitParam = "&value=" + newData.amount;
    //     return client().post(
    //       "api/v1/emp/set_weekly_subsidy" + employeeIdParam + mealType + limitParam
    //     );
    //   }
    //   if(newData.timeSlot.includes("limit_for")) {
    //     if (newData.id !== "ALL") {
    //       const indexOfCurrEmployee = state.listOfOfficeEmployeesAll.findIndex(
    //         obj => {
    //           return obj.id == newData.id;
    //         }
    //       );
    //     }
    //   }
    // },
    UPDATE_DAILY_EMPLOYEE_SUBSIDY({ commit }, newData) {
      return new Promise((resolve, reject) => {
        setEmployeeDailySubsidy(newData)
          .then(res => {
            commit("SET_EMPLOYEE_SUBSIDY", newData);
            resolve(res);
          })
          .catch(err => {
            console.log("err: ", err);
            reject(err);
            // errorHandler(err);
          });
      });
    },
    UPDATE_WEEKLY_EMPLOYEE_SUBSIDY({ commit }, newData) {
      setWeeklyEmployeeSubsidy(newData)
        .then(res => {
          commit("SET_EMPLOYEE_SUBSIDY", newData);
        })
        .catch(err => {
          console.log("err: ", err);
          errorHandler(err);
        });
    },
    UPDATE_CURRENT_OFFICE_ADMIN_TEAM: (state, params) => {
      getOfficeTeams(state.getters.getFirstEmployeeId).then(response => {
        const data = response?.data;
        let filteredTeam = data?.data?.filter(team => team.id == params.teamId);

        if (filteredTeam?.length > 0) {
          state.commit("SET_OFFICE_ADMIN_TEAM", filteredTeam[0]);
        }
      });
    },
    SAVE_NON_CHECKED_OUT_CART(state, data) {
      axios
        .post(
          `https://api.airtable.com/v0/${airTableApp}/${airTableName}/`,
          { fields: data },
          {
            headers: {
              Authorization: "Bearer " + apiToken,
              "Content-Type": "application/json"
            }
          }
        )
        .then(response => {
          if (response.data && response.data.id) {
            console.log("DATA SAVED IN air Table");
          }
        });
    }
  },
  mutations: {
    SET_CART: (state, data) => {
      state.cart = Object.assign({}, state.cart, data);
      if (data != null) {
        state.cart.items = data.all_items.data;
        if (state.cart.is_weekly === undefined) state.cart.is_weekly = true;
        if (state.cart.order_date === undefined)
          state.cart.order_date = state.cart.items[0].req_date;
      } else {
        state.cart = {
          items: [],
          subsidized_tip: 0,
          subsidized_hst: 0,
          tip: 0,
          hst: 0,
          hst_rate: 0.13,
          subtotal: 0,
          subsidized_subtotal: 0,
          grand_total: 0,
          payable_amount: 0,
          is_weekly: true,
          available_credit: 0,
          isSubsidy: false
        };
      }
    },
    SET_UNCHECKED_OUT_ORDER: (state, data) => {
      state.uncheckedoutOrder = Object.assign(
        {},
        state.uncheckedoutOrder,
        data
      );
      if (data != null) {
        state.uncheckedoutOrder.items = data?.attributes?.order_items;
        if (state.uncheckedoutOrder.is_weekly === undefined)
          state.cart.is_weekly = true;
        if (state.uncheckedoutOrder.order_date === undefined)
          state.uncheckedoutOrder.order_date =
            state.uncheckedoutOrder.items[0].req_date;
      } else {
        state.uncheckedoutOrder = {
          items: [],
          subsidized_tip: 0,
          subsidized_hst: 0,
          tip: 0,
          hst: 0,
          hst_rate: 0.13,
          subtotal: 0,
          subsidized_subtotal: 0,
          grand_total: 0,
          payable_amount: 0,
          is_weekly: true,
          available_credit: 0,
          isSubsidy: false
        };
      }
    },
    SET_CART_OFFICE_ADMIN: (state, data) => {
      state.cartOfficeAdmin = Object.assign({}, state.cartOfficeAdmin, data);
      if (data != null) {
        state.cartOfficeAdmin.items = data.all_items.data;
        if (state.cartOfficeAdmin.is_weekly === undefined)
          state.cartOfficeAdmin.is_weekly = true;
        if (state.cartOfficeAdmin.order_date === undefined)
          state.cartOfficeAdmin.order_date =
            state.cartOfficeAdmin.items[0].req_date;
      } else {
        state.cartOfficeAdmin = {
          items: [],
          subsidized_tip: 0,
          subsidized_hst: 0,
          tip: 0,
          hst: 0,
          hst_rate: 0.13,
          subtotal: 0,
          subsidized_subtotal: 0,
          grand_total: 0,
          payable_amount: 0,
          is_weekly: true,
          available_credit: 0,
          isSubsidy: false
        };
      }
    },

    SET_RESTAURANT_DIRECTORY_FILTERS: (
      state,
      currChosenFilter = "",
      filterType = ""
    ) => {
      let existingUserChosenTags = [
        ...state.restaurantDirectoryData.dietaryChosenTags,
        ...state.restaurantDirectoryData.cuisineChosenTags
      ];

      // if passed in 'reset', then reset filters. Could be a whole separte func?
      if (currChosenFilter === "reset") {
        state.restaurantDirectoryData.dietaryChosenTags = [];
        state.restaurantDirectoryData.cuisineChosenTags = [];
        return;
      }

      // removing ability - if it's there, remove it.
      if (existingUserChosenTags.includes(currChosenFilter)) {
        existingUserChosenTags = existingUserChosenTags.filter(
          f => f !== currChosenFilter
        );
      } else {
        // adding ability - if it's not there, add it.
        if (filterType === "dietary")
          dietaryChosenTags = [currChosenFilter, ...dietaryChosenTags];
        if (filterType === "cuisine")
          cuisineChosenTags = [currChosenFilter, ...cuisineChosenTags];
      }
    },

    UPDATE_SUBSIDY_PRESENT: (state, data) => {
      state.cart.isSubsidy = data;
    },

    UPDATE_SUBSIDY_PRESENT_OFFICE_ADMIN: (state, data) => {
      state.cartOfficeAdmin.isSubsidy = data;
    },

    SET_SHOW_DEFAULT_OFFICE_SELECTION: (state, data) => {
      state.showDefaultOfficeSelectionModal = data;
    },

    UPDATE_SUBSIDY: (state, newSubsidy) => {
      state.subsidyDetails = newSubsidy;
    },
    UPDATE_SUBSIDY_OFFICE_ADMIN: (state, newSubsidy) => {
      state.subsidyDetailsOfficeAdmin = newSubsidy;
    },

    UPDATE_PAYMENT_CART: (state, update = {}) => {
      state.paymentCart = Object.assign({}, state.paymentCart, update);
    },
    UPDATE_PAYMENT_CART_OFFICE_ADMIN: (state, update = {}) => {
      state.paymentCartOfficeAdmin = Object.assign(
        {},
        state.paymentCartOfficeAdmin,
        update
      );
    },

    RESET_STATE(state) {
      for (let f in state) {
        Vue.set(state, f, initialState[f]);
      }
    },

    RESET_CART(state) {
      state.cart = Object.assign({}, initialState.cart);
    },
    RESET_CART_OFFICE_ADMIN(state) {
      state.cartOfficeAdmin = Object.assign({}, initialState.cartOfficeAdmin);
    },
    SET_CURRENT_EMPLOYEE: (state, data) => {
      state.currentEmp = data.data.attributes;
    },
    SET_LOCATION: (state, data) => {
      state.location = data.data.attributes;
    },
    SET_ORGANIZATION: (state, data) => {
      state.currentOrganization = data;
    },
    SET_TZINFO: (state, data) => {
      state.timezone = data;
    },
    SET_UNCHECKED_OUT_ORDER_ID: (state, data) => {
      state.uncheckedoutOrderId = data;
    },
    SET_INVITATION_SLUG: (state, data) => {
      state.invitationSlug = data;
    },
    UPDATE_EMPLOYEE: (state, data) => {
      state.employee = data.attributes;

      let filteredEmployees = data.attributes.employees.filter(
        employee =>
          employee.attributes.organization_type === "Location" &&
          employee.attributes.organization_active &&
          !employee.attributes.soft_deleted &&
          employee?.attributes?.active
      );

      if (
        !data.attributes.default_selected ||
        state.validLocations.length !== filteredEmployees.length
      )
        state.showDefaultOfficeSelectionModal = true;

      state.validLocations = filteredEmployees;

      window.fcWidget.user.setProperties({
        firstName: data?.attributes?.first_name,
        lastName: data?.attributes?.last_name,
        office:
          data.attributes.employees?.length > 0 &&
          state?.currentOrganization &&
          state?.currentOrganization?.attributes?.organization_name,
        email: ""
      });
    },
    SET_EMPLOYEE: (state, data) => {
      state.employee = data.attributes;

      let locationEmployees = data.attributes.employees.filter(
        employee =>
          employee.attributes.organization_type === "Location" &&
          employee.attributes.organization_active
      );

      let filteredEmployees = data.attributes.employees.filter(
        employee =>
          employee.attributes.organization_type === "Location" &&
          employee.attributes.organization_active &&
          !employee.attributes.soft_deleted &&
          employee.attributes.uncatering &&
          employee?.attributes?.active
      );

      const defaultOrg = filteredEmployees.filter(
        employee => employee.attributes.default
      );

      state.currentOrganization =
        defaultOrg.length > 0
          ? [...defaultOrg].shift()
          : filteredEmployees?.length > 0
          ? [...filteredEmployees].shift()
          : [...locationEmployees].shift();

      state.validLocations = filteredEmployees;

      window.fcWidget.user.setProperties({
        firstName: data?.attributes?.first_name,
        lastName: data?.attributes?.last_name,
        office:
          data?.attributes?.employees?.length > 0 &&
          state?.currentOrganization &&
          state?.currentOrganization?.attributes?.organization_name,
        email: ""
      });

      window.fcWidget.setTags(["loggedin"]);

      // filteredEmployees.length === 0
      //   ? [
      //       ...data.attributes.employees.filter(
      //         employee =>
      //           employee.attributes.organization_type === "Location" &&
      //           employee.attributes.organization_active
      //       )
      //     ].shift()
      //   : [...filteredEmployees].shift();

      // Set Freshchat user settings
      // if (state.employee.user.user_type === 1) {
      //   // If user is an office admin
      //   window.fcWidget.user.setProperties({
      //     firstName: state.employee.name,
      //     lastName: `Admin Account ${state.employee.office.display_name}`,
      //     office: state.employee.office.name,
      //     email: state.employee.email
      //   });
      // } else {

      // }
    },
    UPDATE_TIP: (state, data) => {
      state.tip = data;
      state.defaultTip = false;
    },
    UPDATE_TIP_OFFICE_ADMIN: (state, data) => {
      state.tipOfficeAdmin = data;
      state.defaultTipOfficeAdmin = false;
    },
    UPDATE_RESTAURANT_DATE: (state, data) => {
      state.restaurantDate = data;
    },
    TOGGLE_ADMIN_MENU(state) {
      state.adminMenuOpen = !state.adminMenuOpen;
    },
    SHOW_ADMIN_MENU(state) {
      state.adminMenuOpen = true;
    },
    HIDE_ADMIN_MENU(state) {
      state.adminMenuOpen = false;
    },
    SHOW_ADMIN_BUTTON_MENU(state) {
      state.adminMenuButtonHide = true;
    },
    RESET_ADMIN_BUTTON_MENU(state) {
      state.adminMenuButtonHide = false;
    },
    TOGGLE_ADMIN_LOGIN(state) {
      state.isAdminLogin = !state.isAdminLogin;
    },
    SHOW_ALERT(state, data) {
      state.alert = data.value;
      state.alertMsg = data.msg;
    },
    SET_OFFICE_EMPLOYEES_LIST_ALL(state, data) {
      state.listOfOfficeEmployeesAll = data;
    },
    SET_OFFICE_ADMINS(state, data) {
      state.officeAdmins = data;
    },
    SET_OFFICE_TEAMS(state, data) {
      state.officeTeamsAll = data;
    },
    SET_EMPLOYEE_SUBSIDY(state, newData) {
      if (newData.id === "ALL") {
        if (newData.timeSlot.includes("limit_for")) {
          state.listOfOfficeEmployeesAll.forEach(employee => {
            employee.daily_limits[newData.timeSlot] = newData.amount;
          });
          return;
        }
      }

      if (newData.id !== "ALL") {
        const indexOfCurrEmployee = state.listOfOfficeEmployeesAll.findIndex(
          obj => {
            return +obj.id === +newData.id;
          }
        );
        if (newData.timeSlot.includes("weekly")) {
          state.listOfOfficeEmployeesAll[indexOfCurrEmployee][
            newData.timeSlot
          ] = newData.amount;
          return;
        }
        if (newData.timeSlot.includes("limit_for")) {
          state.listOfOfficeEmployeesAll[indexOfCurrEmployee].daily_limits[
            newData.timeSlot
          ] = newData.amount;
        }
      }
    },
    SET_OFFICE_ADMIN_RESTAURANT_ORDER: (state, data) => {
      state.restaurantOrder = data;
    },
    SET_OFFICE_ADMIN_TEAM: (state, data) => {
      state.officeTeam = data;
    },
    SET_SELECTED_USER_TO_PLACE_ORDER_OFA: (state, data) => {
      state.selectedUserToPlaceOrder = data;
    },
    UPDATE_CURRENT_OPENED_MENU_ITEM_ID: (state, id) => {
      state.currentOpenedMenuItemId = id;
    },
    SET_ORDERS_DATE_OFFICE_ADMIN(state, date) {
      state.ordersDateOA = date;
    },
    SET_ENABLE_CREDIT_CARDS(state, data) {
      state.enableCards = data;
    },
    SET_MEAL_NAME(state, data) {
      state.mealName = data;
    },
    SET_PREVIOUSLY_SELECTED_MEAL(state, data) {
      state.previouslySelectedMeal = data;
    }
  },
  getters: {
    getFirstEmployeeCredit: state => {
      return state.currentEmp.credit;
    },
    getPreviouslySelectedMeal: state => {
      return state.previouslySelectedMeal;
    },
    getFirstEmployee: state => {
      return state.currentOrganization;
    },
    getFirstEmployeeId: state => {
      return state.currentOrganization ? state.currentOrganization.id : null;
    },
    getUncheckedoutOrderId: state => {
      return state.uncheckedoutOrderId;
    },
    getInvitationSlug: state => {
      return state.invitationSlug;
    },
    getOrganizationId: state => {
      return state.currentOrganization
        ? state.currentOrganization.attributes.organization_id
        : null;
    },
    getFirstLocation: state => {
      return state.location;
    },
    getSelectedUserPlaceOrder: state => {
      return state.selectedUserToPlaceOrder;
    },
    getTipValues: state => {
      // if (state.employee.office.show_tip) {
      //   if (
      //     state.employee &&
      //     state.employee.office != null &&
      //     state.employee.office.tip_values != null
      //   ) {
      //     return state.employee.office.tip_values.split(",");
      //   } else return [0, 5, 10];
      // } else {
      //   return 0;
      // }
      return [0, 5, 10];
    },
    getAlert: state => {
      return state.alert;
    },
    getAlertMessage: state => {
      return state.alertMsg;
    },
    getItemsCount: state => {
      return state.cart.items.length;
    },
    getSubsidy: state => {
      return state.cart.isSubsidy;
    },
    getRestaurantDate: state => {
      return state.restaurantDate;
    },
    getRestaurantDirectoryFilters: state => {
      return state.restaurantDirectoryData.allUserChosenTags;
    },
    getIsAdminLogin: state => {
      return state.isAdminLogin;
    },
    getEnableCreditCards: state => {
      return state.enableCards;
    },
    getMealName: state => {
      return state.mealName;
    }
  },

  methods: {},

  plugins: [createPersistedState()]
});



// WEBPACK FOOTER //
// ./src/store.js